import * as React from 'react';
import { Container } from 'reactstrap';
import { Logo } from '../logo/Logo';
import { NavLinkList } from '../nav-link-list/NavLinkList';
import './Hero.css';
//import Particles from 'react-particles-js';

export class Hero extends React.Component<any,{}> {

  render() {
    return (
        <div className="hero-bg">
          <Container className="hero-container p-0">
            <Logo/>
            <NavLinkList type="hero"/>
          </Container>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/hero/Hero.tsx